import React, { useEffect, useRef } from 'react'
import { useRive, Layout, Fit, Alignment } from '@rive-app/react-canvas'
import { graphql, useStaticQuery } from 'gatsby'
import { useInView } from 'framer-motion'

export const FooterLogo = ({ className = '' }: { className?: string }) => {
  const {
    datoCmsFooter: {
      content: [{ content }],
    },
  } = useStaticQuery(graphql`
    {
      datoCmsFooter {
        content {
          content {
            ... on DatoCmsFooterLogo {
              logoSubtext
            }
          }
        }
      }
    }
  `)

  const data = content
    .flat()
    .reduce((acc: {}, curr: {}) => ({ ...acc, ...curr }), {})
  const subtext: string = data.logoSubtext

  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: '100px' })

  const { rive, RiveComponent } = useRive({
    src: 'https://ucarecdn.com/75ff21cb-587a-448e-8ec8-5cd6fcd15ae6/pvllogopinwheel.riv',
    layout: new Layout({
      fit: Fit.Contain,
      alignment: Alignment.Center,
    }),
    autoplay: false,
  })

  useEffect(() => {
    if (isInView && rive) {
      rive.play()
    }
  }, [isInView, rive])

  return (
    <div className={`flex flex-col items-center pt-8 ${className}`}>
      <div
        ref={ref}
        className="mx-auto pb-3 xl:ml-0 xl:mr-auto"
        style={{ height: '50px', width: '40px' }}
      >
        <RiveComponent />
      </div>
      {subtext && (
        <div className="max-w-[240px] text-center text-sm text-blue-300 xl:max-w-full xl:text-left">
          {subtext}
        </div>
      )}
    </div>
  )
}
